import React from 'react';
import css from './accuracy-graph.scss';

const GRAPH_PROPERTIES = {
    HEIGHT: 50,
    WIDTH: 104
};

export const drawHorizontalBarLines = (averageAccuracies) => {
    if (averageAccuracies.length === 0) return null;

    const Bars = [];

    let minAccuracy =
        Math.floor(
            averageAccuracies.reduce((a, b) =>
                a.accuracy < b.accuracy ? a : b
            ).accuracy / 10
        ) * 10;

    let maxAccuracy =
        Math.ceil(
            averageAccuracies.reduce((a, b) =>
                a.accuracy > b.accuracy ? a : b
            ).accuracy / 10
        ) * 10;

    if (minAccuracy === maxAccuracy) {
        minAccuracy = minAccuracy !== 0 ? (minAccuracy -= 10) : minAccuracy;
        maxAccuracy = maxAccuracy !== 100 ? (maxAccuracy += 10) : maxAccuracy;
    }

    for (let i = minAccuracy; i <= maxAccuracy; i += 10) {
        Bars.unshift(
            <div className={css.row} key={i} data-testid="graph-bar">
                {(i === minAccuracy || i === maxAccuracy) && (
                    <div className={css.percentage}>{i}%</div>
                )}
                <div className={css.barline} />
            </div>
        );
    }

    return Bars;
};

export const renderGraph = (averageAccuracies) => {
    if (averageAccuracies.length === 0) return null;

    const Graph = [];

    if (averageAccuracies.length === 1) {
        const pointPosition =
            GRAPH_PROPERTIES.HEIGHT -
            (GRAPH_PROPERTIES.HEIGHT / (averageAccuracies[0].accuracy * 2)) *
                averageAccuracies[0].accuracy;

        return (
            <span className={css.graphline}>
                <div
                    className={css.graphPoint}
                    style={{ top: `${pointPosition}px` }}
                />
            </span>
        );
    }

    const COLUMN_WIDTH =
        GRAPH_PROPERTIES.WIDTH / (averageAccuracies.length - 1);

    for (let i = 0; i < averageAccuracies.length - 1; i++) {
        const minAccuracy =
            Math.floor(
                averageAccuracies.reduce((a, b) =>
                    a.accuracy < b.accuracy ? a : b
                ).accuracy / 10
            ) * 10;

        const maxAccuracy =
            Math.ceil(
                averageAccuracies.reduce((a, b) =>
                    a.accuracy > b.accuracy ? a : b
                ).accuracy / 10
            ) * 10;
        const y1 =
            GRAPH_PROPERTIES.HEIGHT -
            (GRAPH_PROPERTIES.HEIGHT / (maxAccuracy - minAccuracy)) *
                (averageAccuracies[i].accuracy - minAccuracy);
        const y2 =
            GRAPH_PROPERTIES.HEIGHT -
            (GRAPH_PROPERTIES.HEIGHT / (maxAccuracy - minAccuracy)) *
                (averageAccuracies[i + 1].accuracy - minAccuracy);
        Graph.push(
            <span
                style={{ width: `${COLUMN_WIDTH}px` }}
                className={css.graphline}
                key={i}
            >
                <svg
                    height={GRAPH_PROPERTIES.HEIGHT}
                    width={COLUMN_WIDTH}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <polyline
                        points={`0, ${y1}, ${COLUMN_WIDTH}, ${y2}`}
                        style={{
                            fill: 'none',
                            stroke: '#00b4eb',
                            strokeWidth: 1
                        }}
                    />
                </svg>
            </span>
        );
    }

    return Graph;
};



// WEBPACK FOOTER //
// ./components/accuracy-graph/accuracy-graph.utils.js